<template>
  <products-base-view status="all"></products-base-view>
</template>

<script>
import ProductsBaseView from "@/components/products/ProductsBaseView";
export default {
  name: 'AllProductsView',
  inheritAttrs: false,
  components: {ProductsBaseView},
};
</script>
